import dayjs from 'dayjs';

export const singleTaskMocked = {
  taskId: '123',
  customerNumber: '74946',
  eid: '12345',
  taskType: 'untitled_content_item',
  taskConfig: 'return_to_work',
  responsibleParty: 'employee',
  assignee: 'test@unum.com',
  taskStatus: 'Open',
  notificationCaseId: 'NTN-123',
  caseId: 'NTN-123-ABS-01',
  formItems: [
    {
      inputName: 'What is your expected return to work date?',
      inputValue: '2023-03-15',
      inputType: 'input',
    },
    {
      inputName: 'Why are you returning later than previously expected?',
      inputValue: 'My doctor says I need more time',
      inputType: 'radioButton',
    },
    {
      inputName: 'Are you returning Full-Time or Part-Time?',
      inputValue: 'Full Time',
      inputType: 'radioButton',
    },
  ],
  notes:
    'Please provide your expected return to work date. This helps us know how much time you will need. From this date, we can determine what benefits you might be eligible to receive.',
  modifiedDate: '2023-03-10',
  modifiedBy: 'agent',
  taskDueDate: dayjs().format('YYYY-MM-DD'),
};

export const draftTasksMocked = [
  {
    taskId: '123',
    customerNumber: '74946',
    eid: '12345',
    taskType: 'untitled_content_item',
    taskConfig: 'return_to_work',
    responsibleParty: 'employee',
    assignee: 'test@unum.com',
    taskStatus: 'Draft',
    notificationCaseId: 'NTN-123',
    caseId: 'NTN-123-ABS-01',
    formItems: [
      {
        inputName: 'What is your expected return to work date?',
        inputValue: '2023-03-15',
        inputType: 'input',
      },
      {
        inputName: 'Why are you returning later than previously expected?',
        inputValue: 'My doctor says I need more time',
        inputType: 'radioButton',
      },
      {
        inputName: 'Are you returning Full-Time or Part-Time?',
        inputValue: 'Full Time',
        inputType: 'radioButton',
      },
    ],
    notes:
      'Please provide your expected return to work date. This helps us know how much time you will need. From this date, we can determine what benefits you might be eligible to receive.',
    modifiedDate: '2023-03-10',
    modifiedBy: 'agent',
    taskDueDate: dayjs().format('YYYY-MM-DD'),
  },
  {
    taskId: '123',
    customerNumber: '74946',
    eid: '12345',
    taskType: 'submit_w4_recommended_task',
    taskConfig: 'w4',
    responsibleParty: 'employee',
    assignee: 'test@unum.com',
    taskStatus: 'Draft',
    notificationCaseId: 'NTN-123',
    caseId: 'NTN-123-ABS-01',
    formItems: [
      {
        inputName: 'Please upload your W4 form',
        inputValue: '2023-03-15',
        inputType: 'upload',
      },
    ],
    notes: 'Please upload your W4 form. This will affect your payments.',
    modifiedDate: '2023-03-10',
    modifiedBy: 'agent',
    taskDueDate: dayjs().format('YYYY-MM-DD'),
  },
];
